// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify';
import createStore from './store';
import router from './router';
import {createAxioInstance, multiEndpointService, default as service} from './service';
import auth from './auth';
import {HandlerPlugin} from './errorHandler';
import Socket from './sockets/authenticator';
import registerSocketCallbacks from './sockets/registerCallbacks';

// Import CSS dependencies
import 'vuetify/dist/vuetify.css';
import './style/global.less';
import theme from './style/variables';

// Components to render on page
import App from './views/App';

Vue.config.productionTip = false;

Vue.use(Vuex);

Vue.use(Vuetify, {
  theme: {
    primary: theme['@edval-light'],
    error: theme['@edval-red']
  }
});

const authenticatorUrl = `${window.location.protocol}//${window.location.host}`;

createAxioInstance(authenticatorUrl).get('/config')
  .then((response) => {
    Vue.configuration = Vue.prototype.$configuration = response.data.data;

    Vue.configuration.services.authenticator = authenticatorUrl + '/api';

    // Install services
    Vue.use(service('authenticator', Vue.configuration.services.authenticator));
    Vue.use(multiEndpointService('cloud', [Vue.configuration.services.cloud]));
    // Vue.use(service('cloud', config.services.cloud));

    Vue.use(service('enterprise', Vue.configuration.services.enterprise));
    Vue.use(service('zoho', Vue.configuration.services.zoho));
    Vue.use(service('domainsapi', Vue.configuration.services.domainsapi));
    Vue.use(service('messaging', Vue.configuration.services.messaging));
    Vue.use(service('websocket', Vue.configuration.services.websocket));

    const store = createStore(Vue.services);

    Vue.use(HandlerPlugin, {
      version: Vue.configuration.build.version,
      store,
    });

    const socket = new Socket(Vue.services);
    socket.connect();

    // Install authentication
    Vue.use(auth, {
      service: 'authenticator',
      store,
      storeNamespace: 'auth',
      router,
      refreshCallbacks: [
        // Authenticate to websocket
        () => Promise.resolve().then(() => socket.authenticate()),
        // Refresh list of accessible schools whenever we refresh the JWT
        () => store.dispatch('cloud/initialize', true).catch(() => { }),
      ],
    });

    registerSocketCallbacks(socket, store, auth);

    new Vue({
      el: '#app',
      store,
      router,
      render: (el) => el(App),
    });
  })
  .catch();

